(function() {

  'use strict';

  /**
   * Bundle Component
   * @type BundleCmpCtrl
   * @name BundleCtrl
   */
  var BundleCmp = {
      bindings: {
        product: '<'
      },
      controller: BundleCmpCtrl,
      templateUrl: 'bundle.component.html'
  };

  angular.module('itxApp.catalog')
      .component('bundle', BundleCmp);

  BundleCmpCtrl.$inject = [
    'ItxUtilsFct', 
    '$rootScope', 
    'ItxConfigurationSvc',
    'BundleSvc',
    'ItxScreenSizeSvc',
    'ProductRelatedSvc',
    'imProductService',
    'logger',
    'ItxTranslateSvc',
    'productPopupSvc'
  ];

  function BundleCmpCtrl(
    ItxUtilsFct,
    $rootScope, 
    ItxConfigurationSvc,
    BundleSvc,
    ItxScreenSizeSvc,
    ProductRelatedSvc,
    imProductService,
    logger,
    ItxTranslateSvc,
    productPopupSvc
  ) {

      var _this = this;

      var COMING_SOON = joyr.constants.visibility.COMMING_SOON_VISIBILITY;
      var BACK_SOON = joyr.constants.visibility.BACK_SOON_VISIBILITY;
      var SHOW = joyr.constants.visibility.SHOW_VISIBILITY;

      _this.submitted = false;
      _this.isMobile = ItxScreenSizeSvc.is('xs');
      _this.isTablet = ItxScreenSizeSvc.is('sm');
      _this.textTotal = ItxTranslateSvc.translateCms('legacy.ItxQuickPurchase.Total');

      _this.$onInit = function(){
        inditex.onReady(function(){
          _this.isOpenForSale = joyr.catalog.utils.isOpenForSale();
        });
        _this.init();
      };

      _this.$onChanges = function(changes){
        var somethingChanged = ( changes.product && !changes.product.isFirstChange() && changes.product.currentValue != changes.product.previousValue);
        if (somethingChanged) {
          _this.init();
        }
      };

      _this.init = function () {
       // _this.images = _this.getBundleImage();
        _this.submitted = false;
        BundleSvc.parseBundleProducts(_this.product).then(function (res) {
          _this.bundleProducts = res;
          
          // enganchamos el boton de comprar al top y le damos el mismo alto que las imagenes
          if(!_this.isMobile && !_this.isTablet){
            setTimeout(function () {
              var elemItems =  $('.ma-product-bundle-container');
              var imagesGridHeight = $('#product-images-grid').height();
              var itemsBundleHeight = elemItems.height();

              if(imagesGridHeight > itemsBundleHeight){
                elemItems.css( {"height": imagesGridHeight});
              }
              
              var top = 64;
              if($('body').hasClass('ban-single')){
                top = top + 25;
              } else if($('body').hasClass('ban-double')){
                top = top + 50;
              }
              
              $(".js-scroll-element-first").stick_in_parent({offset_top: top });

            }, 100);
          }

        });
        imProductService.createViewBundle(_this.product, _this.product.state.selectedColorIndex);
      };

      _this.getTotalPrice = function() {
        var total = 0;
        _this.itemsQuantity = 0;
        _.map(_this.bundleProducts, function(p) {
          if(p.bundleProductSelected.checked){
            _this.itemsQuantity++;
            total = total + parseInt(p.activeDetail.colors[p.state.selectedColorIndex].sizes[p.state.selectedSizeIndex].price);
          }
        });
        return inditex.formatPrice(total) || 0;
      };

      _this.onSelectedSize = function(size, productId) {
        _this.bundleProducts = _.map(_this.bundleProducts, function(p) {
          if(productId === p.id){
            p.state.selectedSize = size;
            p.bundleProductSelected.checked = true;
            imProductService.eventSelectSize(p, size, p.state.selectedColorIndex);
            if(size.visibility === COMING_SOON || size.visibility === BACK_SOON){
              productPopupSvc.openStockAvailability(p);
            }
          }
          return p;
        });
      };
      
      _this.validateBundleItems = function () {
        var isValid = true;
        var checkedProduct = false;
        _.map(_this.bundleProducts, function(p) {
          if (p.bundleProductSelected.checked && !p.state.selectedSize || 
              p.bundleProductSelected.checked && p.state.selectedSize && p.state.selectedSize.visibility != SHOW) {    
            isValid = false;
          } else if (p.bundleProductSelected.checked) {
            checkedProduct = true;
          }
        });
        return isValid && checkedProduct;
      };

      _this.onSelected = function(productId) {
        _this.bundleProducts = _.map(_this.bundleProducts, function(p) {
          if(productId === p.id){
            (p.bundleProductSelected.checked)? false: true;
          }
          return p;
        });
      };

      _this.addToCart = function() {
        _this.submitted = true;

        if(_this.validateBundleItems()){
          // si tiene talla y al menos uno esta seleccionado enviamos al carrito
          BundleSvc.addItemsToCart(_this.bundleProducts)
            .then(function(res) {
              _this.product.state.bundleItemsAdded = res;
              ProductRelatedSvc.openPopupRelateds(angular.copy(_this.product));
            })
            .catch(function (err) {
              logger.logError('NO SE HAN AÑADIDO', err);
            });
        } else {
          if(!_this.isTablet){
            var invalidElem = $('.bundle-item-invalid.bundle-item-selected').offset();
            var heightButton = $('.js-scroll-element-first').height() + 100; // 100 para tener en cuenta el header
            if(invalidElem){
              invalidElem = invalidElem.top;
            } else if(_this.isMobile){
              invalidElem = $('.js-scroll-element-first').offset().top;
            } else {
              invalidElem = 0;
            }
            $('html,body').animate({ scrollTop: invalidElem - heightButton }, 250);
          }
        }
      };

     /* _this.getBundleImage = function() {
        return ItxUtilsFct.getImageProductUrls(_this.product.activeDetail, _this.product.mainColorid, 'productPage', 'lookBook', 'bundleProducts');
      };*/
      
      _this.zoom = function($event) {
        var color = !_this.isProductBean ? null : _this.colorId;
        var images = ItxUtilsFct.getImageProductUrls(_this.product.activeDetail, color, 'productPage', 'lookbook', 'zoom');
        var thumbnails = ItxUtilsFct.getImageProductUrls(_this.product.activeDetail, color, 'productPage', 'lookbook', 'orderItem');
        $rootScope.$broadcast('itx-product-zoom:initialize', {
            images: images,
            index: 0,
            event: $event,
            productId: _this.product.id,
            thumbnails: thumbnails 
        });
      };

  }

})();
